import { render, staticRenderFns } from "./FlightTab.vue?vue&type=template&id=4be28b58&scoped=true&"
import script from "./FlightTab.vue?vue&type=script&lang=js&"
export * from "./FlightTab.vue?vue&type=script&lang=js&"
import style0 from "./FlightTab.vue?vue&type=style&index=0&id=4be28b58&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be28b58",
  null
  
)

export default component.exports